import { useState, useEffect } from 'react';

export default function MobileCta() {
  const [show, setShow] = useState(false);
  const [inContact, setInContact] = useState(false);

  useEffect(() => {
    // Show after scrolling past hero
    const heroEl = document.getElementById('home');
    const contactEl = document.getElementById('contact');

    const scrollObserver = new IntersectionObserver(
      ([entry]) => setShow(!entry.isIntersecting),
      { threshold: 0 }
    );

    const contactObserver = new IntersectionObserver(
      ([entry]) => setInContact(entry.isIntersecting),
      { threshold: 0.1 }
    );

    if (heroEl) scrollObserver.observe(heroEl);
    if (contactEl) contactObserver.observe(contactEl);

    return () => {
      scrollObserver.disconnect();
      contactObserver.disconnect();
    };
  }, []);

  const visible = show && !inContact;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden"
      style={{
        transform: visible ? 'translateY(0)' : 'translateY(100%)',
        transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <div className="flex border-t border-white/10 bg-black/95 backdrop-blur-md">
        {/* Call button */}
        <a
          href="tel:0353242299"
          className="flex-1 flex items-center justify-center gap-2 py-4 text-white/80 text-xs tracking-wider border-r border-white/10 active:bg-white/5 transition-colors"
        >
          <i className="ri-phone-line text-base" />
          <span>電話する</span>
        </a>

        {/* Contact button */}
        <button
          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          className="flex-[2] flex items-center justify-center gap-2 py-4 bg-white text-black text-xs font-medium tracking-widest active:bg-white/85 transition-colors cursor-pointer"
        >
          <i className="ri-mail-line text-base" />
          <span>お問い合わせ</span>
        </button>
      </div>
    </div>
  );
}
